<div [hidden]="guestCheckout == true" class="mb-3 ">
  <!-- List of cards -->
  <div class="ucx-accordion">
    <div class="ucx-accordion-header">
      <div class="title-icon">
        <i class="material-icons">
          credit_card
        </i>
        <div class="main-title mt-0 mb-0">
          <h5>Current credit cards</h5>
        </div>
      </div>
      <div class="add-new">
        <img src="assets/images/cards/visa.svg">
        <img src="assets/images/cards/maestro.svg">
        <img src="assets/images/cards/american-express.svg">
      </div>
    </div>
    <div class="ucx-accordion-header">
      <div class="title-icon">
        <p class="m-0">Safe money transfer using your bank account</p>
      </div>
      <a (click)="onAddNewCard()" *appPermissions="permissions.canUserCreateAndUpdateCard" class="add-new">Add New</a>
    </div>
    <div [ngClass]="{'ucx-accordion-body': true, 'card-empty': (!cards || !cards.length) }">
      <ul *ngIf="cards">
        <li *ngFor="let card of cards; let i = index" class="stripe-card">
          <app-stripe-card-item (stripeItemChanged)="onStripeItemChanged($event)" [cardOptions]="{ cardIndex: i }"
                                [card]="card" [defaultCard]="defaultCard"
                                [permissions]="permissions"></app-stripe-card-item>
        </li>
      </ul>
      <p *ngIf="(!cards || !cards.length)">You have not added any Cards yet, please press “Add new” to add your
        Card.</p>
    </div>
  </div>
</div>

<div *ngIf="guestCheckout == false" [hidden]="addNewCard === false" class="stripe-form stripe-form-modal"
     id="stripe-form">
  <div class="stripe-title">
    <div class="row">
      <div class="col">
        <div class="main-title-ucx">
          <div class="d-flex align-itmes-center justify-content-between mb-10">
            <div class="main-title mt-0 mb-0">
              <h5>Add a New Credit Card</h5>
            </div>

            <div mat-dialog-content>
              <!--Delete-->
              <button (click)="closeCreditCardForm()" class="close" data-dismiss="modal" type="button">&times;</button>
            </div>
          </div>
          <div class="line"></div>
        </div>
      </div>
    </div>
  </div>

  <!-- Stripe Form -->
  <form (ngSubmit)="onSubmit()" [formGroup]="stripeForm">
    <div>
      <div class="row">
        <div class="col-12">
          <!-- Full Name -->
          <div class="form-group">
            <label>Card Holder Name <span class="required-symbol">*</span></label>
            <input autocomplete="off" class="form-control" formControlName="name" placeholder="Card Holder Name"
                   type="text">
            <span *ngIf="tooltipService.getState('name')">
              <app-tooltip
                [errorMessages]="tooltipService.inputValidation('name', defaultRequired, defaultExists, defaultInvalid)"
                [position]="'below'"
                [fieldName]="'Card Holder Name'">
              </app-tooltip>
            </span>
          </div>
        </div>
        <div class="col-12">
          <!-- Card Number -->
          <div class="form-group">
            <label>Card Number*</label>
            <ngx-stripe-card

              [elementsOptions]="elementsOptions"
            ></ngx-stripe-card>
          </div>
        </div>
      </div>
      <!--      <div class="row">-->
      <!--        <div class="col-md-6">-->
      <!--          &lt;!&ndash; Card Expiry &ndash;&gt;-->
      <!--          <div class="form-group">-->
      <!--            <label>Expiration Date*</label>-->
      <!--            <div class="field" id="card-expiry"></div>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--        <div class="col-md-6">-->
      <!--          &lt;!&ndash; Card CVC &ndash;&gt;-->
      <!--          <div class="form-group">-->
      <!--            <label>CVC*</label>-->
      <!--            <div class="field" id="card-cvc"></div>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->

      <div class="row align-items-center">
        <!-- todo: after release implement it
        <div class="col-xl-10">
            <div class="form-check">
                <input class="form-check-input" type="checkbox" id="confirm" (click)="onCheckBoxClicked()">
                <label class="form-check-label" for="confirm">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </label>
            </div>
        </div>
        -->
        <div class="col">
          <!--<a type="submit">-->
          <!--<mat-icon>-->
          <!--save-->
          <!--</mat-icon>-->
          <!--Save credit card info-->
          <!--</a>-->
          <div class="save-stripe-card">
            <mat-checkbox (click)="onSubmit()" [value]="false">Save Card</mat-checkbox>
            <!--<a (click)="onSubmit()" class="add-new">-->
            <!--<i class="material-icons">-->
            <!--save-->
            <!--</i>-->
            <!--Save credit card info</a>-->
          </div>

          <!--<button type="submit" class="btn-default" [disabled]="confirmBtnDisabled">-->
          <!--Confirm-->
          <!--</button>-->
        </div>
      </div>
    </div>
  </form>
  <hr>
</div>

<div *ngIf="guestCheckout == true" class="stripe-form stripe-form-modal" id="stripe-form">
  <!-- Stripe Form -->
  <form (ngSubmit)="onSubmit()" [formGroup]="stripeForm">
    <div>
      <div (ngInit)="loadCardElements()" class="row">
        <div class="col-12">
          <!-- Full Name -->
          <div class="form-group">
            <label>Card Holder Name*</label>
            <input autocomplete="off" class="form-control" formControlName="name" placeholder="Card Holder Name"
                   type="text">
            <span *ngIf="tooltipService.getState('name')">
              <app-tooltip
                [errorMessages]="tooltipService.inputValidation('name', defaultRequired, defaultExists, defaultInvalid)"
                [position]="'below'"
                [fieldName]="'Card Holder Name'">
              </app-tooltip>
            </span>
          </div>
        </div>
        <div class="col-12">
          <!-- Card Number -->
          <div class="form-group">
            <label>Card Number*</label>
            <div class="field" id="card-number"></div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <!-- Card Expiry -->
          <div class="form-group">
            <label>Expiration Date*</label>
            <div class="field" id="card-expiry"></div>
          </div>
        </div>
        <div class="col-md-6">
          <!-- Card CVC -->
          <div class="form-group">
            <label>CVC*</label>
            <div class="field" id="card-cvc"></div>
          </div>
        </div>
      </div>

      <div class="row align-items-center">
        <!-- todo: after release implement it
        <div class="col-xl-10">
            <div class="form-check">
                <input class="form-check-input" type="checkbox" id="confirm" (click)="onCheckBoxClicked()">
                <label class="form-check-label" for="confirm">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </label>
            </div>
        </div>
        -->
        <div class="col">
          <!--<a type="submit">-->
          <!--<mat-icon>-->
          <!--save-->
          <!--</mat-icon>-->
          <!--Save credit card info-->
          <!--</a>-->
          <div class="save-stripe-card">
            <mat-checkbox (click)="onSubmit()" [formControl]="checkBoxControl">Use Card to pay</mat-checkbox>
            <!--<a (click)="onSubmit()" class="add-new">-->
            <!--<i class="material-icons">-->
            <!--save-->
            <!--</i>-->
            <!--Save credit card info</a>-->
          </div>

          <!--<button type="submit" class="btn-default" [disabled]="confirmBtnDisabled">-->
          <!--Confirm-->
          <!--</button>-->
        </div>
      </div>
    </div>
  </form>
  <hr>
</div>
